module.exports = __webpack_public_path__ + "img/icono_cargos_rh.0d2645d9.svg";